module.exports = __webpack_public_path__ + "img/transnistria.9ddf9349.svg";